/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"

import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import AnzenKanriService from "../../../service/driver/anzenKanri/anzenKanriService"
import {
  TAnzenKanriZissiListGetReq,
  TAnzenKanriZissiListGetRes,
} from "../../../service/driver/anzenKanri/TAnzenKanri"
import BusyoService from "../../../service/master/busyo/busyoService"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import dateUtil from "../../../ts/util/dateUtil"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"

/**
 * 安全管理一覧
 * @returns
 */
const AnzenKanriZissiList = () => {
  const history = useHistory()
  const location = useLocation()

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "AnzenKanriZissiList_GridId"

  const { eigyobiStr: 営業日 } = useSelector((state: RootState) => state.date)

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TAnzenKanriZissiListGetRes>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  const beforeSearch = () => {
    // バリデーションチェック
    if (!isValidationCheckBeforeSearch()) return
    search()
  }

  /**
   * 検索時のチェック
   */
  const isValidationCheckBeforeSearch = () => {
    dispatch(clearAlert())
    Form外エラーメッセージList.splice(0, Form外エラーメッセージList.length)

    let hasError = false
    let messages: Array<string> = []

    if (hasError) {
      Form外エラーメッセージList.push(...messages)
      setHasSearched(hasError)
    }
    return !hasError
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TAnzenKanriZissiListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TAnzenKanriZissiListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new AnzenKanriService().getZissiList(
        currentSearchCondition
      )

      dispatch(setAlerts(res))

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TAnzenKanriZissiListGetReq = queryString.parse(
      location.search
    ) as TAnzenKanriZissiListGetReq
    set実施年月(
      dateUtil.format(query.実施年月, "YYYY/MM/1") ??
        dateUtil.format(営業日, "YYYY/MM/1")
    )
    set部所コード(query.部所コード)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TAnzenKanriZissiListGetReq => {
    return {
      実施年月: dateUtil.format(実施年月, "YYYY/MM/1"),
      部所コード,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TAnzenKanriZissiListGetReq
  ) => {
    const disp部所 = 部所ItemSource?.find(
      (i) => i.部所コード === searchCondition.部所コード
    )
    return {
      実施年月: dateUtil.format(実施年月, "YYYY/MM"),
      部所: disp部所 ? `${disp部所.部所コード} ${disp部所.部所名}` : undefined,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set部所コード("")
    set実施年月(dateUtil.format(営業日, "YYYY/MM/1"))
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
      }
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  const [comboDataInitialized, setComboDataInitialized] =
    useState<boolean>(false)

  // errorフラグ
  const [hasSearched, setHasSearched] = useState(false)
  const [Form外エラーメッセージList] = useState<string[]>([])
  //#endregion

  //#region [state]
  const [部所コード, set部所コード] = useState<T部所マスタ["部所コード"]>()
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  const [実施年月, set実施年月] = useState<string | null>(営業日)

  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所isLoadEnded, set部所isLoadEnded] = useState<boolean>(false)

  //#endregion

  //#region [effect]

  useEffect(() => {
    if (!部所isLoadEnded) return

    if (!comboDataInitialized) setComboDataInitialized(true)
  }, [comboDataInitialized, 部所isLoadEnded])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && comboDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, comboDataInitialized])

  useEffect(() => {
    document.title = `安全会議実施一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      const 運行部所List = 部所ListRes.data.filter(
        (b) => b.運行部所フラグ === 1
      )
      set部所ItemSource(運行部所List)
    })
  }, [])

  // error監視
  useEffect(() => {
    if (hasSearched && [...Form外エラーメッセージList].find((e) => e !== "")) {
      dispatch(setWarningAlerts([...Form外エラーメッセージList]))
    }
    setHasSearched(false)
  }, [hasSearched])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">安全会議実施一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-60rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <MonthInput
                              id="実施年月"
                              value={実施年月}
                              setValue={(v) => set実施年月(v!)}
                              placeholder="実施年月"
                            />
                            <ComboBox.Busyo
                              placeholder="部所"
                              className="w-20rem"
                              isLoadEnded={部所isLoadEnded}
                              setIsLoadEnded={set部所isLoadEnded}
                              isAllSelect={true}
                              isRequired={true}
                              itemsSource={部所ItemSource}
                              selectedValue={部所コード}
                              setSelectedValue={(v) => {
                                set部所コード(v ?? undefined)
                              }}
                              listFilter={(d) => d.運行部所フラグ === 1}
                              ComboBox={部所ComboBox}
                              setComboBox={set部所ComboBox}></ComboBox.Busyo>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            beforeSearch()
                          }}>
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}>
                <wjrGrid.FlexGridColumn
                  binding="管理NO"
                  width={128}
                  header="会議No"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  width={200}
                  header="会議名"
                  binding="会議名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="実施日"
                  width={200}
                  header="出席日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TAnzenKanriZissiListGetRes>
                    ) => {
                      return dateUtil.format(context.item.実施日)
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  width={100}
                  header="社員番号"
                  binding="社員コード"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員氏名"
                  width={180}
                  header="氏名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  width={100}
                  header="部所CD"
                  binding="部所コード"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="部所略称"
                  width={180}
                  header="部所"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default AnzenKanriZissiList
